import { render } from "./trivia.vue?vue&type=template&id=39d819da&scoped=true"
import script from "./trivia.vue?vue&type=script&lang=js"
export * from "./trivia.vue?vue&type=script&lang=js"

import "./trivia.vue?vue&type=style&index=0&id=39d819da&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d819da"],['__file',"src/components/trivia.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39d819da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39d819da', __exports__)) {
    api.reload('39d819da', __exports__)
  }
  
  module.hot.accept("./trivia.vue?vue&type=template&id=39d819da&scoped=true", () => {
    api.rerender('39d819da', render)
  })

}


export default __exports__